import {
    REQUEST_ADVISORS,
    RELOAD_ADVISORS,
    RECEIVE_ADVISORS,
    UPDATE_ADVISORS,
    ERROR_ADVISORS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"
const ifs = {
    list: {...initialFetchState},
    tree: {...initialFetchState}
}

export default (state = ifs, action = {}) => {
    const s = {...state}
    switch(action.type) {
        case REQUEST_ADVISORS:
            s[action.subtype] = {
                ...s[action.subtype],
                isFetching: true,
                message: '',
                errors: {}
            }
            return s
        case RECEIVE_ADVISORS:
            s[action.subtype] = {
                ...s[action.subtype],
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
            return s
        case RELOAD_ADVISORS:
            s[action.subtype] = {
                ...s[action.subtype],
                shouldReload: true
            }
            return s
        case UPDATE_ADVISORS:
            const data = state[action.subtype].data
            let index = null
            switch(action.updateType) {
                case 'create':
                    data.results.push(action.payload)
                    break
                case 'update':
                    if(data.results){
                        index = data.results.findIndex(item => item.id == action.id)
                        data.results[index] = action.payload
                    }
                    break
                case 'delete':
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                    break
            }
            s[action.subtype] = {
                ...s[action.subtype],
                isFetching: false,
                data,
                errors: action.errors
            }
            return s
        case ERROR_ADVISORS:
            s[action.subtype] = {
                ...s[action.subtype],
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
            return s
        default:
            return state
    }
}